// Imports
var ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ = require("../../../../node_modules/html-loader/dist/runtime/getUrl.js");
var ___HTML_LOADER_IMPORT_0___ = require("../../../images/wip-banner-small.png");
// Module
var ___HTML_LOADER_REPLACER_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var code = "<md-content class=md-padding> <div class=\"lv-body stop-propagate\"> <div class=lv-item> <div class=work-in-progress-ctn-elm> <div class=work-in-progress-content> <img src=" + ___HTML_LOADER_REPLACER_0___ + "> <p>{{'WIP' | translate}}</p> </div> </div> </div> </div> </md-content> ";
// Exports
module.exports = code;